import { PauseIcon } from 'lucide-react';

import ControlButton from './ControlButton';

function PauseButton({ onClick }: { onClick: () => void }) {
  return (
    <ControlButton variant="pause" data-testid="pause-button" onClick={onClick} className="w-36" aria-label="Pause timer">
      <PauseIcon className="size-6" />
    </ControlButton>
  );
}

export default PauseButton;
